<template>
  <div class="tariffs">
    <v-tariff-create-update-form v-if="this.isShowModal" @close="closeModal" />
    <v-tariff-groups v-if="this.isShowTariffGroups" @close="closeModal" />
    <div class="row pb-3">
      <div class="col-lg-4">Всего: {{ tariffList.count }}</div>
      <div class="col-lg-4 text-center" v-if="userData.role === 'administrator'">
        <button @click="showModal" class="btn-primary">Добавить тариф</button>
      </div>
      <div class="col-lg-4 text-center" v-if="userData.role === 'administrator'">
        <button @click="showTariffGroups" class="btn-primary">Группы тарифов</button>
      </div>
    </div>
    <div v-if="this.loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-grow m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="search-phone">По названию</label>
            <input class="form-control" id="search-phone" v-model="searchName"
                      @input="getFilteredTariffList()"
                      @focusin="InputFocusIn('search-phone')"
                      @focusout="InputFocusOut('search-phone')"/>
          </div>
        </div>
        <div v-if="userData.role === 'administrator' || userData.role === 'employee'"
             class="col-6">
          <div class="form-group">
            <label for="search-last-name">По внутреннему имени</label>
            <input class="form-control" id="search-last-name" v-model="searchInternalName"
                      @input="getFilteredTariffList()"
                      @focusin="InputFocusIn('search-last-name')"
                      @focusout="InputFocusOut('search-last-name')"/>
          </div>
        </div>
        <div class="col-6 text-center pb-2"
             v-if="userData.role === 'administrator' || userData.role === 'employee'">
          <multiselect
            v-model="searchDealer"
            :options="userList"
            track-by="id"
            label="last_name"
            placeholder="Выберите дилера"
            @input="getFilteredTariffList()"
            :allow-empty="true">
            <template slot="singleLabel" slot-scope="{ option }">
              {{ option.last_name }}
            </template>
          </multiselect>
        </div>
        <div class="col-6 text-center pb-2"
             v-if="userData.role === 'administrator' || userData.role === 'employee'">
          <multiselect
            v-model="searchTariffGroup"
            :options="tariffGroupList"
            track-by="id"
            label="name"
            placeholder="Выберите группу"
            @input="getFilteredTariffList()"
            :allow-empty="true">
            <template slot="singleLabel" slot-scope="{ option }">
              {{ option.name }}
            </template>
          </multiselect>
        </div>
      </div>
      <v-tariff-table :tariff-list="this.tariffList.results" :role="userData.role"
                      @update="getFilteredTariffList()" />
      <v-paginator :data="tariffList" @change="pageCallback" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';
import VTariffTable from '../../components/tables/v-tariff-table.vue';
import VTariffCreateUpdateForm from '../../components/forms/v-tariff-create-update-form.vue';
import VPaginator from '../../components/layouts/v-paginator.vue';
import VTariffGroups from '../../components/modals/v-tariff-groups.vue';

export default {
  name: 'Tariffs',
  components: {
    VTariffGroups,
    VPaginator,
    VTariffCreateUpdateForm,
    VTariffTable,
    Multiselect,
  },
  data() {
    return {
      isShowModal: false,
      isShowTariffGroups: false,
      searchTariffGroup: '',
      searchDealer: '',
      searchName: '',
      searchInternalName: '',
      loading: true,
      fullFilter: '',
      page: 1,
    };
  },
  computed: {
    ...mapState('tariff', ['tariffList', 'tariffGroupList']),
    ...mapState('user', ['userList']),
    ...mapState('user', ['userData']),
  },
  methods: {
    ...mapActions('tariff', ['getTariffList', 'getTariffGroupList']),
    ...mapActions('user', ['getUserList']),
    pageCallback(pageNum) {
      this.page = pageNum;
      this.getFilteredTariffList();
    },
    getFilteredTariffList() {
      this.fullFilter = `?page=${this.page}`;
      if (this.searchDealer) {
        this.fullFilter += `&dealer=${this.searchDealer.id}`;
      }
      if (this.searchTariffGroup) {
        this.fullFilter += `&tariff_group=${this.searchTariffGroup.id}`;
      }
      if (this.searchName) {
        this.fullFilter += `&name=${this.searchName}`;
      }
      if (this.searchInternalName) {
        this.fullFilter += `&internal_name=${this.searchInternalName}`;
      }
      this.getTariffList(this.fullFilter)
        .then(() => { this.loading = false; });
    },
    showModal() {
      this.isShowModal = true;
    },
    showTariffGroups() {
      this.isShowTariffGroups = true;
    },
    closeModal() {
      this.isShowModal = false;
      this.isShowTariffGroups = false;
      this.loading = true;
      this.getTariffGroupList('?get_all=true');
      this.getFilteredTariffList();
    },
  },
  mounted() {
    if (this.userData.role === 'administrator' || this.userData.role === 'employee') {
      this.getTariffGroupList('?get_all=true');
      this.getUserList('?role=dealer&get_all=true');
    }
    this.getFilteredTariffList();
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
